module.exports = __webpack_public_path__ + "img/社区活动.a4381eab.png";